import { render, staticRenderFns } from "./SelectedNanogenre.vue?vue&type=template&id=87939c30&scoped=true&"
import script from "./SelectedNanogenre.vue?vue&type=script&lang=js&"
export * from "./SelectedNanogenre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87939c30",
  null
  
)

export default component.exports